export default {
      id: "d-usage",
      viewBox: "0 0 300 335",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#d-usage",
      toString: function () {
        return this.url;
      }
    }